// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3XHtl","col":"styles_col__2Emzx"};